<template>
  <div id="app">
    <Header msg="Header"/>
    <Cookies msg="Cookies"/>
    <Footer msg="Footer"/>
  </div>
</template>

<script>
/*componenti*/
import Header from '../../components/Header.vue'
import Cookies from '../../components/Cookies.vue'
import Footer from '../../components/Footer.vue'


export default {
  name: 'app',
  components: {
    Header,
    Cookies,
    Footer,
  },
  constants: {
    HTMLTITLE: 'SCTOutil.VDA',
    NODE_ENV: process.env.NODE_ENV
  },
  data() {
      return {
        pageGA:'/default/cookies',
      }},
   
  mounted(){
    
    //start bootstrap
    var recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', '/SCTProfessional/static/node_modules/startbootstrap-modern-business/vendor/jquery/jquery.min.js');
    document.head.appendChild(recaptchaScript);
    recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', '/SCTProfessional/static/node_modules/startbootstrap-modern-business/vendor/bootstrap/js/bootstrap.bundle.min.js');
    document.head.appendChild(recaptchaScript);
  }
}

</script>

